(function () {
    'use strict';

    angular
        .module('app.ReturnOnInvestmentSetting')
        .controller('ReturnOnInvestmentSettingCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance', 'ReturnOnInvestmentSettingService',
            function ($scope, $modal, $http, $rootScope, $modalInstance, ReturnOnInvestmentSettingService)
            {
                $scope.currentUser = $rootScope.currentUser;
                $scope.currencySymbol = "";
                $scope.cpmBlogString = 1;
                $scope.cpmInstagramString = 1;
                $scope.cpmYouTubeString = 1;
                $scope.cpmSnapchatString = 1;
                $scope.cpmTwitterString = 1;
                $scope.cpmPinterestString = 1;
                $scope.cpmFacebookString = 1;

                $scope.htmlSymbol = true;
                $scope.currencies = [
                    {label: 'Euro (&#8364;)', value: 0},
                    {label: 'US Dollar ($)', value: 1},
                    {label: 'Danish Krone (DKK)', value: 2},
                    {label: 'Norwegian Kroner (NOK)', value: 3},
                    {label: 'Swedish Krona (SEK)', value: 4}
                ];
                $scope.currencies[0].ticked = true;
                $scope.currency = 0;

                $scope.methods = [
                    {label: 'Engagement Fueled CPM', value: 0}
                ];
                $scope.methods[0].ticked = true;

                $scope.selectCurrency = function (data) {
                    switch(data.value) {
                        case 0:
                            $scope.currencySymbol = "";
                            $scope.htmlSymbol = true;
                            $scope.currency = 0;
                            break;
                        case 1:
                            $scope.currencySymbol = "$";
                            $scope.htmlSymbol = false;
                            $scope.currency = 1;
                            break;
                        case 2:
                            $scope.currencySymbol = "DKK";
                            $scope.htmlSymbol = false;
                            $scope.currency = 2;
                            break;
                        case 3:
                            $scope.currencySymbol = "NOK";
                            $scope.htmlSymbol = false;
                            $scope.currency = 3;
                             break;
                        case 4:
                            $scope.currencySymbol = "SEK";
                            $scope.htmlSymbol = false;
                            $scope.currency = 4;
                            break;
                        default:
                    }
                }

                $scope.getROISettings = function ()
                {
                    if($scope.currentUser.role.accessLevel == 'admin' || $scope.currentUser.role.accessLevel == 'agency') {
                        $scope.companyID = $rootScope.sideMenuSelections.advertiserId;
                        var params = {
                            company_id: $scope.companyID
                        }
                    }
                    
                    if($scope.currentUser.role.accessLevel == 'advertiser') {
                        $scope.companyID = $scope.currentUser.company.id;
                        var params = {
                            company_id: $scope.companyID
                        }
                    }

                    ReturnOnInvestmentSettingService.getCPM(params, true)
                        .then(function(result){
                            if(result.data != null) {
                                $scope.cpmBlogString = Math.round(result.data.blog * 100) / 100
                                $scope.cpmInstagramString = Math.round(result.data.instagram * 100) / 100;
                                $scope.cpmYouTubeString = Math.round(result.data.youtube * 100) / 100;
                                $scope.cpmSnapchatString = Math.round(result.data.snapchat * 100) / 100;
                                $scope.cpmTwitterString = Math.round(result.data.twitter * 100) / 100;
                                $scope.cpmPinterestString = Math.round(result.data.pinterest * 100) / 100;
                                $scope.cpmFacebookString = Math.round(result.data.facebook * 100) / 100;
                                angular.forEach($scope.currencies, function(item) {
                                    item.ticked = false;
                                    if(item.value == result.data.currency) {
                                        $scope.selectCurrency(item);
                                        item.ticked = true;
                                    }
                                })
                            }
                        })
                        .catch(function(message){

                        })
                        .finally(function(){

                        });
                }

                $scope.getROISettings();


                $scope.saveSetting = function()
                {
                    var params = {
                        company_id: $scope.companyID,
                        method: $scope.methods[0].value,
                        currency: $scope.currency,
                        blog: Math.round($scope.cpmBlogString * 100) / 100,
                        instagram: Math.round($scope.cpmInstagramString * 100) / 100,
                        youtube: Math.round($scope.cpmYouTubeString * 100) / 100,
                        snapchat: Math.round($scope.cpmSnapchatString * 100) / 100,
                        twitter: Math.round($scope.cpmTwitterString * 100) / 100,
                        pinterest: Math.round($scope.cpmPinterestString * 100) / 100,
                        facebook: Math.round($scope.cpmFacebookString * 100) / 100
                    }
                    ReturnOnInvestmentSettingService.setCPM(params, true)
                    .then(function(result){
                        $modalInstance.close();
                    }, function(result) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = result.message;
                    })
                    .catch(function(message){

                    })
                    .finally(function(){

                    });
                }

                $scope.closeModal = function()
                {
                    $modalInstance.dismiss();
                }

            }
        ]);
})();
